import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { teamsAPI } from '../services/api';

const TeamContext = createContext();

export function TeamProvider({ children }) {
  const [teams, setTeams] = useState([]);
  const [activeTeam, setActiveTeam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchTeams = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await teamsAPI.getAll();
      const teamList = res.data?.data || [];
      setTeams(teamList);

      // Restore previously selected team from localStorage
      const savedTeamId = localStorage.getItem('activeTeamId');
      if (savedTeamId && teamList.find(t => t._id === savedTeamId)) {
        setActiveTeam(teamList.find(t => t._id === savedTeamId));
      } else if (teamList.length > 0) {
        setActiveTeam(teamList[0]);
        localStorage.setItem('activeTeamId', teamList[0]._id);
      } else {
        setActiveTeam(null);
        localStorage.removeItem('activeTeamId');
      }
    } catch (err) {
      setError('Your teams could not be loaded. Try again before creating or choosing a team.');
      console.error('Failed to fetch teams');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) fetchTeams();
    else setLoading(false);
  }, [fetchTeams]);

  const switchTeam = (teamId) => {
    const team = teams.find(t => t._id === teamId);
    if (team) {
      setActiveTeam(team);
      localStorage.setItem('activeTeamId', team._id);
    }
  };

  const refreshTeams = () => fetchTeams();

  return (
    <TeamContext.Provider value={{ teams, activeTeam, switchTeam, refreshTeams, loading, error }}>
      {children}
    </TeamContext.Provider>
  );
}

export function useTeam() {
  return useContext(TeamContext);
}
